import { getButton } from './Button';
import { clearCookies } from '../utilities/Cookies';
import styles from '../styles/Styles';

import ic_error from '../images/cancel_b.png';

export const ERR_NO_CONNECTION = 1, ERR_EMPTY_FIELD = 2, ERR_INTERNAL_USER = 3,
  ERR_SESSION_RESET = 4, ERR_REGULAR = 5, ERR_PHOTO_PENDING = 7,
  ERR_PHOTO_DOCUMENT = 8, ERR_GO_HOME = 9, ERR_REFRESH = 10, ERR_PRESENCE = 11,
  ERR_REGULAR_FUNC = 12, ERR_PERMISSION = 13, ERR_PHOTO_NOO = 14, ERR_DOC_NOO = 15;

function getImageError(TAG, context) {
  let icon = ic_error;
  if (context.state[TAG].result !== null) {
    switch (context.state[TAG].result.action) {
      case ERR_NO_CONNECTION: // ERROR NO CONNECTION
      case ERR_EMPTY_FIELD: // ERROR EMPTY FIELD
      case ERR_INTERNAL_USER: // ERROR INTERNAL USER
      case ERR_SESSION_RESET: // ERROR GO TO HOME
      case ERR_PRESENCE:
      case ERR_REGULAR:
      case ERR_PHOTO_PENDING:
      case ERR_DOC_NOO:
      case ERR_PHOTO_NOO:
      case ERR_PHOTO_DOCUMENT:
      case ERR_GO_HOME: // UNEXPECTED ERROR THEN GO TO HOME
      case ERR_REFRESH: // NEED TO REFRESH PAGE
      case ERR_REGULAR_FUNC: // ERROR WITH FUNCTION
      case ERR_PERMISSION: // ERROR PERMISSION
      default:
        break;
    }
  }
  return (
    <div style={{display : 'flex', flexDirection : 'row', margin : '30px 0'}}>
      <img alt='' src={icon} style={{margin : '30px auto 30px'}}/>
    </div>
  );
}

function getTitleError(TAG, context) {
  let title = 'Oops!';
  if (context.state[TAG].result !== null) {
    switch (context.state[TAG].result.action) {
      case ERR_NO_CONNECTION: // ERROR NO CONNECTION
        title = 'Koneksi Lemah';
        break;
      case ERR_EMPTY_FIELD: // ERROR EMPTY FIELD
        title = 'Field Kosong';
        break;
      case ERR_INTERNAL_USER:
        title = 'Fatal Error';
        break;
      case ERR_SESSION_RESET: // ERROR GO TO HOME
        title = 'Session Reset';
        break;
      case ERR_PHOTO_PENDING:
        title = 'Foto Pending';
        break;
      case ERR_DOC_NOO:
        title = 'Dalam Approval';
        break;
      case ERR_PHOTO_NOO:
      case ERR_PHOTO_DOCUMENT:
        title = 'Scan Gagal';
        break;
      case ERR_GO_HOME:
        title = 'Data Invalid';
        break;
      case ERR_REFRESH:
        title = 'Refresh Halaman';
        break;
      case ERR_PRESENCE:
        title = 'Belum Absen';
        break;
      case ERR_PERMISSION:
        title = 'Izin Ditolak';
        break;
      case ERR_REGULAR_FUNC:
      case ERR_REGULAR:
      default:
        break;
    }
  }
  return <div className='crs_default fnt_ntv_a txt_20 txt_bold' style={{textAlign : 'center'}}><span>{title}</span></div>
}

async function getErrorAction(TAG, context) {
  if (context.state[TAG].result._func === undefined) { context.state[TAG].result._func = null; }
  switch (context.state[TAG].result.action) {
    case ERR_SESSION_RESET: // ERROR GO TO LOGIN
      clearCookies();
      window.open('/', '_self');
      break;
    case ERR_INTERNAL_USER: // ERROR INTERNAL USER
      window.open(`mailto:helpdesk@tokopintar.co.id?subject=REPORT_ERROR&body=${encodeURIComponent('Ceritakan pada kami dimana anda menemukan error ini, dan kirimkan juga screen shot dari halaman tersebut.')}`);
      break;
    case ERR_PHOTO_PENDING:
      window.open('/status_photo', '_self');
      break;
    case ERR_DOC_NOO:
      window.open('/retail_noo', '_self');
      break;
    case ERR_PHOTO_NOO:
      window.open('/scan_visit?page=approve_noo', '_self');
      break;
    case ERR_PHOTO_DOCUMENT:
      window.open('/scan_visit?page=update_profile', '_self');
      break;
    case ERR_GO_HOME:
      window.open('/dashboard', '_self');
      break;
    case ERR_REFRESH:
      window.location.reload();
      break;
    case ERR_PRESENCE:
      window.open('/salesman_wholesaler?page=salesman_location', '_self');
      break;
    case ERR_PERMISSION:
      window.open('https://drive.google.com/file/d/1noM_kk3411HE8hwBJoj2-TRIaziAYOCL/view?usp=share_link', '_blank');
      break;
    case ERR_REGULAR_FUNC:
      context.state[TAG].result._func();
      break;
    case ERR_NO_CONNECTION: // ERROR NO CONNECTION
    case ERR_EMPTY_FIELD: // ERROR EMPTY FIELD
    case ERR_REGULAR:
    default:
      context.setState({ [TAG] : null });
      break;
  }
}

export function showErrorPage(context) {
  if (context.state.error_page === undefined) { context.state.error_page = null; }
  if (context.state.error_page !== null) {
    return (
      <div style={m_style.root_page}>
        <div style={{...m_style.dialog_container, ...{background : 'none'}}}>
          <div style={{padding : 20}}>
            { getTitleError('error_page', context) }
            <div className='fnt_blk_a txt_14 crs_default' style={{margin : '15px 0 0 0', textAlign : 'center', wordWrap : 'break-word'}}><span>{context.state.error_page.message}</span></div>
            { getImageError('error_page', context) }
            { context.state.error_page.result === null ? null : getButton({text : context.state.error_page.result.message, text_class : 'txt_14 fnt_wht_a', inner_style : {...styles.ntv_bg_color_b, ...{borderRadius : 10}}}, () => getErrorAction('error_page', context)) }
          </div>
        </div>
      </div>
    );
  }
}

export function showErrorDialog(context) {
  if (context.state.error_dialog === undefined) { context.state.error_dialog = null; }
  if (context.state.error_dialog !== null) {
    let s_action = (context.state.error_dialog.result === null) ? 'Tutup' : context.state.error_dialog.result.message;
    return (
      <div onClick={() => context.setState({ error_dialog : null })} style={m_style.root_dialog} >
        <div onClick={(e) => e.stopPropagation()} style={m_style.dialog_container}>
          <div style={{flex : 1, display : 'flex', flexDirection : 'column', padding : 20}}>
            { getTitleError('error_dialog', context) }
            <div className='fnt_blk_a txt_14 crs_default' style={{margin : '15px 0 0 0', textAlign : 'center', wordWrap : 'break-word'}}>{context.state.error_dialog.message}</div>
            { getImageError('error_dialog', context) }
            { getButton({text : s_action, text_class : 'fnt_wht_a txt_14', inner_style : {...styles.ntv_bg_color_b, ...{borderRadius : 10}}}, () => { (context.state.error_dialog.result === null) ? context.setState({ error_dialog : null }) : getErrorAction('error_dialog', context) }) }
          </div>
        </div>
      </div>
    );
  } else { return null; }
}

const m_style = {
  root_page : {
    display : 'flex',
    flexDirection : 'column',
    width : '100%',
    height : '100%',
    background : 'white',
    position : 'fixed',
    overflow : 'auto'
  },
  root_dialog : {
    display : 'flex',
    flexDirection : 'column',
    position : 'fixed',
    overflow : 'auto',
    zIndex : 4,
    top : 0, left : 0,
    width : '100%',
    height : '100%',
    backgroundColor : 'rgba(0, 0, 0, 0.5)'
  },
  dialog_container : {
    display : 'flex',
    flexDirection : 'column',
    width : '80%',
    maxWidth : 300,
    backgroundColor : 'white',
    borderRadius : 10,
    margin : 'auto'
  }
}
